import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import { COLUMNS_PERSON } from "../../Constants/DatatableColumns";
import { PENCIL } from "../../Constants/SrcImages";
import { Row, Col, Container, Button, Label } from "reactstrap";
import { PersonModal } from "./../../Constants/Modal";
import moment from "moment";
import { ITypePerson, ITypeBlood, IPerson } from "./../../Constants/Interfaces";
import { getAllPerson, putPerson, postPerson, getTypePerson, getTypeBlood } from "../../Constants/Services";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";
import { FIND_DESC,validateTokenStorage } from "../../Constants/Util";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface IPersonState {
  dataPerson: IPerson[];
  formPerson: IPerson;
  loading: boolean;
  isOpenModalPerson: boolean;
  isOpenModalPersonEdit: boolean;
  dataTPerson: ITypePerson[];
  formTPerson: ITypePerson;
  dataTBlood: ITypeBlood[];
  formTypeBlood: ITypeBlood;
  msg_error: string;
}

class Person extends Component<RouteComponentProps<{}>, IPersonState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataPerson: [],
      formPerson: {
        per_id: "",
        per_cedula: "",
        per_type: "",
        per_name: "",
        per_lastname: "",
        per_typeb: "",
        per_celphone1: "",
        per_celphone2: "",
        per_email: "",
        per_birthday: new Date().toString(),
        per_sex: "",
        per_info: "",
      },
      dataTPerson: [],
      formTPerson: {
        typ_id: "",
        typ_desc: "",
      },
      dataTBlood: [],
      formTypeBlood: {
        tb_id: "",
        tb_desc: "",
      },
      loading: false,
      isOpenModalPerson: false,
      isOpenModalPersonEdit: false,
      msg_error: "",
    };

    this.fetchTypeBlood = this.fetchTypeBlood.bind(this);
    this.fetchPerson = this.fetchPerson.bind(this);
    this.handlerSavePerson = this.handlerSavePerson.bind(this);
    this.handlerPutPerson = this.handlerPutPerson.bind(this);
    this.onChangePerson = this.onChangePerson.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.handleModalAddPerson = this.handleModalAddPerson.bind(this);
    this.handleModalEditPerson = this.handleModalEditPerson.bind(this);
    this.setTypePerson = this.setTypePerson.bind(this);
    this.onChangeDatePicker = this.onChangeDatePicker.bind(this);
    this.handlerSetDataEdit = this.handlerSetDataEdit.bind(this);
    this.openModalEditPerson = this.openModalEditPerson.bind(this);
  }

  async fetchTypeBlood() {
    const response = await getTypeBlood();
    this.setState({
      dataTBlood: response,
      loading: false,
    });
  }

  async fetchPerson() {
    const response = await getAllPerson();
    this.setState({
      dataPerson: response,
      loading: false,
    });
  }

  async fetchTypePerson() {
    const response = await getTypePerson();
    this.setState({ dataTPerson: response, loading: false });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchPerson();
    this.fetchTypePerson();
    this.fetchTypeBlood();
  }

  handlerSavePerson() {
    const props = this.state.formPerson;
    const propsF = this.state.formTPerson;
    const propsTB = this.state.formTypeBlood;
    if (!FIND_DESC(this.state.dataPerson, props.per_cedula)) {
      if (props.per_cedula.length > 0 && props.per_name.length>0 && props.per_lastname.length>0 && props.per_birthday.length>0 && props.per_sex.length>0 && propsF.typ_id.length > 0 && props.per_celphone1.length > 0 && propsTB.tb_id.length > 0) {
        const body = {
          per_cedula: props.per_cedula.replace(/\s+/g, ''),
          per_type: propsF.typ_id,
          per_name: props.per_name,
          per_lastname: props.per_lastname,
          per_typeb: propsTB.tb_id,
          per_celphone1: props.per_celphone1,
          per_celphone2: props.per_celphone2,
          per_email: props.per_email,
          per_birthday: props.per_birthday,
          per_sex: props.per_sex,
          per_info: props.per_info,
        };

        postPerson(body);
        this.setState({ isOpenModalPerson: false, loading: true, msg_error: "" });
        setTimeout(() => {
          this.fetchPerson();
        }, 1000);
      } else {
        this.setState({ msg_error: "Campos importantes estan vacios" });
      }
    } else {
      this.setState({ msg_error: "Ya existe una persona registrada con esta cedula " + props.per_cedula });
      this.fetchPerson();
    }
  }

  handlerPutPerson() {
    const props = this.state.formPerson;
    const propsF = this.state.formTPerson;
    const propsTB = this.state.formTypeBlood;
    const body = {
      per_id: props.per_id,
      per_cedula: props.per_cedula,
      per_type: propsF.typ_id,
      per_name: props.per_name,
      per_lastname: props.per_lastname,
      per_typeb: propsTB.tb_id,
      per_celphone1: props.per_celphone1,
      per_celphone2: props.per_celphone2,
      per_email: props.per_email,
      per_birthday: props.per_birthday,
      per_sex: props.per_sex,
      per_info: props.per_info,
    };
    putPerson(body);
    this.setState({
      isOpenModalPersonEdit: false,
      loading: true,
      msg_error: "",
    });
    setTimeout(() => {
      this.fetchPerson();
    }, 1000);
  }

  onChangePerson(e: any) {
    this.setState({
      formPerson: {
        ...this.state.formPerson,
        [e.target.name]: e.target.value,
      },
    });
  }

  rechargeData() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchPerson();
    }, 1000);
  }

  handleModalAddPerson() {
    this.setState((prevState) => ({
      isOpenModalPerson: !prevState.isOpenModalPerson,
      formPerson: {
        per_id: "",
        per_cedula: "",
        per_type: "",
        per_name: "",
        per_lastname: "",
        per_typeb: "",
        per_celphone1: "",
        per_celphone2: "",
        per_email: "",
        per_birthday: new Date().toString(),
        per_sex: "M",
        per_info: "",
      },
      formTPerson: {
        typ_id: "",
        typ_desc: "",
      },
      formTypeBlood: {
        tb_id: "",
        tb_desc: "",
      },
      msg_error:""
    }));
  }

  openModalEditPerson() {
    this.setState((prevState) => ({
      isOpenModalPersonEdit: !prevState.isOpenModalPersonEdit,
    }));
  }

  handlerSetDataEdit(row: any) {
    this.setState({
      formPerson: row,
      isOpenModalPersonEdit: true,
      formTPerson: {
        typ_id: row.per_type,
        typ_desc: row.typ_desc,
      },
      formTypeBlood: {
        tb_id: row.per_typeb,
        tb_desc: row.tb_desc,
      },
    });
  }

  handleModalEditPerson(cell: number, row: IPerson) {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handlerSetDataEdit(row)}>
            {row.per_id}
          </Label>
          <img className="img-status img-search" onClick={() => this.handlerSetDataEdit(row)} src={PENCIL} alt="" />
        </Col>
      </Row>
    );
  }

  setTypeBlood = (tb_desc:string, tb_id:string) => {
    this.setState({
      formTypeBlood: {
        ...this.state.formTypeBlood,
        tb_id,
        tb_desc,
      },
    });
  };

  setTypePerson = (typ_desc:string, typ_id:string) => {
    this.setState({
      formTPerson: {
        ...this.state.formTPerson,
        typ_id,
        typ_desc,
      },
    });
  };

  setSexo = (per_sex:string) => {
    this.setState({
      formPerson: {
        ...this.state.formPerson,
        per_sex,
      },
    });
  };

  onChangeDatePicker(date: any) {
    this.setState({
      formPerson: {
        ...this.state.formPerson,
        per_birthday: moment(date).format("YYYY-MM-DD HH:mm:ss"),
      },
    });
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalPerson && (
          <PersonModal
            title="Agregar persona"
            setTypeBlood={this.setTypeBlood}
            dataTBlood={props.dataTBlood}
            dataFTBlood={props.formTypeBlood}
            setTypePerson={this.setTypePerson}
            dataTPerson={props.dataTPerson}
            dataFTPerson={props.formTPerson}
            setSexo={this.setSexo}
            dataFPerson={props.formPerson}
            isOpen={props.isOpenModalPerson}
            toggle={this.handleModalAddPerson}
            toggleSave={this.handlerSavePerson}
            onChange={this.onChangePerson}
            onChangeDatePicker={this.onChangeDatePicker}
            msg_error={props.msg_error}
          />
        )}
        {props.isOpenModalPersonEdit && (
          <PersonModal
            title="Editar persona"
            setTypeBlood={this.setTypeBlood}
            dataTBlood={props.dataTBlood}
            dataFTBlood={props.formTypeBlood}
            setTypePerson={this.setTypePerson}
            dataTPerson={props.dataTPerson}
            dataFTPerson={props.formTPerson}
            setSexo={this.setSexo}
            dataFPerson={props.formPerson}
            isOpen={props.isOpenModalPersonEdit}
            toggle={this.openModalEditPerson}
            toggleSave={this.handlerPutPerson}
            onChange={this.onChangePerson}
            onChangeDatePicker={this.onChangeDatePicker}
            msg_error={props.msg_error}
          />
        )}
        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row className="body-margin">
                <Col sm={12} className="text-center">
                  <h3>Personas</h3>
                </Col>
                <Col sm={12} className="text-right">
                  <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                  <Button color="primary" className="mr-2" onClick={() => this.rechargeData()}>
                    Recargar
                  </Button>
                  <Button color="success" onClick={() => this.handleModalAddPerson()}>
                    Agregar nuevo
                  </Button>
                </Col>
                <Col sm={12}>
                  <Datatable
                    data={props.dataPerson}
                    columns={COLUMNS_PERSON(this.handleModalEditPerson)}
                    keyProp="per_id"
                    exportD={false}
                    searchs={true}
                    selectRows={false}
                    optionSelectRow={null}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Person;
